export enum ActionTypes {
 GET_EXTERNAL_EQUIPMENT = '[GET_EXTERNAL_EQUIPMENT] Get external equipment',
 GET_EXTERNAL_EQUIPMENT_SUCCESS = '[GET_EXTERNAL_EQUIPMENT] Get external equipment success',
 GET_EXTERNAL_EQUIPMENT_FAILURE = '[GET_EXTERNAL_EQUIPMENT] Get external equipment failure',
}
